import React, { useEffect, useRef } from 'react';
import '../styles/GameNavigationBar.css';
import { AGENTS } from '../../globalChat/constants';

const GAME_ICONS = {
  quiz: '/people/quiz.png',
  fillthebox: '/people/fillthebox.png',
  selectgroup: '/people/selectgroup.png',
  matchpairs: '/people/matchpairs.png',
  rearrange: '/people/rearrange.png',
  crossword: '/people/crossword.png',
  scrittura: '/people/scrittura.png',
  video: '/people/video.png',
};

const GameNavigationBar = ({ chats, currentGameIndex, completedGames, onNavigate }) => {
  const navBarRef = useRef(null);
  const activeItemRef = useRef(null);
  const itemRefs = useRef([]);
  
  // Reset item refs array quando il numero di chat cambia
  useEffect(() => {
    itemRefs.current = itemRefs.current.slice(0, chats.length);
  }, [chats.length]);

  // Funzione per forzare lo scroll all'inizio
  const scrollToStart = () => {
    if (navBarRef.current) {
      // Imposta scrollLeft a -1 per forzare lo scroll completo all'inizio
      navBarRef.current.scrollLeft = -1;
    }
  };

  useEffect(() => {
    // Forza lo scrolling all'inizio all'avvio
    scrollToStart();
  }, []);

  useEffect(() => {
    if (navBarRef.current && itemRefs.current[currentGameIndex]) {
      const navBar = navBarRef.current;
      const activeItem = itemRefs.current[currentGameIndex];
      
      if (currentGameIndex === 0) {
        // Per il primo elemento, forza lo scrolling all'inizio
        scrollToStart();
      } else {
        // Per gli altri, usa scrollIntoView con opzioni specifiche
        activeItem.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    }
  }, [currentGameIndex]);

  const hasYoutubeVideo = (chat) => {
    if (!chat || !chat.last_message || !chat.last_message.text) return false;
    try {
      const messageContent = JSON.parse(chat.last_message.text);
      if (messageContent.type === 'youtube' && messageContent.videoId) {
        return true;
      }
    } catch (error) {
      const textContent = chat.last_message.text;
      return textContent.includes('youtube.com') || textContent.includes('youtu.be');
    }
    return false;
  };

  return (
    <nav className="game-navigation-bar" ref={navBarRef}>
      {chats.map((chat, index) => {
        const gameType = chat.agent && chat.agent.toLowerCase();
        let iconPath = null;
        let displayText = '';

        if (gameType && GAME_ICONS[gameType]) {
          if (gameType === 'scrittura') {
            if (hasYoutubeVideo(chat)) {
              iconPath = GAME_ICONS['video'];
              // Trova l'etichetta per 'video' da AGENTS
              const videoAgent = AGENTS.find(agent => agent.key === 'video');
              displayText = videoAgent ? videoAgent.label : 'Video';
            } else {
              iconPath = GAME_ICONS['scrittura'];
              // Trova l'etichetta per 'scrittura' da AGENTS
              const scritturaAgent = AGENTS.find(agent => agent.key === 'scrittura');
              displayText = scritturaAgent ? scritturaAgent.label : 'Lettura';
            }
          } else {
            iconPath = GAME_ICONS[gameType];
            // Trova l'etichetta dell'agente corrispondente da AGENTS
            const agent = AGENTS.find(agent => agent.key === gameType);
            displayText = agent ? agent.label : gameType;
          }
        }

        const isActive = index === currentGameIndex;
        const isCompleted = completedGames.some(g => g.chatId === chat.id);

        return (
          <div 
            key={chat.id}
            className={`game-nav-item ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''}`}
            onClick={() => onNavigate(index)}
            ref={(el) => { itemRefs.current[index] = el; }}
          >
            {iconPath ? (
              <div className="game-nav-icon-wrapper">
                <img src={iconPath} alt={displayText} className="game-nav-icon" />
              </div>
            ) : (
              <span className="game-nav-number">{index + 1}</span>
            )}
            <span className="game-nav-title">{displayText}</span>
          </div>
        );
      })}
    </nav>
  );
};

export default GameNavigationBar;
